import { apiSlice } from "../../../app/services/apiSlice";
import { StyledDot } from "../../job/creation/assets/jobCreationUtill";
const PIPELINE_URL = 'stages';

export const pipelineApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPipelineTemplates: builder.query({
      query: (params) => ({
        url: `${PIPELINE_URL}/pipeline-templates/list`,
        params: params
      })

    }),

    getTemplatesPipe: builder.mutation({
      query: (params) => ({
        url: `${PIPELINE_URL}/pipeline-templates/list`,
        params: params
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.templates?.rows?.map((pipes) => ({
          ...pipes,
          title: pipes?.name,
          value: pipes?.id,
        }));
        return responseData || {};
      },
    }),

    getDefaultPipelineTemplates: builder.query({
      query: () => `${PIPELINE_URL}/company/default`,
    }),
    getSelectedPipelineTemplates: builder.mutation({
      query: (id) => `${PIPELINE_URL}/pipeline-template/${id}/details`,
    }),
    createSettingsPipelineTemplates: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-templates`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    createPipelineTemplates: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-templates/job-hiring`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobCreatePipelineTemplates: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-templates/job-hiring`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    savePipelineStages: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-templates`,
        method: 'PUT',
        body: data,
      }),
    }),
    jobSelectedPipelineStages: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/job-hiring/${data?.jobId}/pipeline-template/${data?.templateId}`,
        method: 'PUT',
      }),
    }),
    jobDefaultPipelineStages: builder.mutation({
      query: (jobId) => ({
        url: `${PIPELINE_URL}/job-hiring/${jobId}/default`,
        method: 'PUT',
      }),
    }),
    jobPipelineStageSwitch: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/job-hiring/switch`,
        method: 'PUT',
        body: data
      }),
    }),
    deletePipelineTemplate: builder.mutation({
      query: (id) => ({
        url: `${PIPELINE_URL}/pipeline-templates/${id}`,
        method: 'DELETE',
      }),
    }),
    deletePipelineTemplateStage: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-templates/${data?.tplId}/stage/${data?.stageId}`,
        method: 'DELETE',
      }),
    }),
    updatePipelineTemplates: builder.mutation({
      query: (data) => ({
        url: `${PIPELINE_URL}/pipeline-template/${data.id}/info`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    getStageTypes: builder.mutation({
      query: (params) => ({
        url: `${PIPELINE_URL}/stage-groups`,
        method: 'GET',
        params: params
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.stageGroups?.map((stageType) => ({
          ...stageType,
          title: <div className='d-flex align-items-center'><StyledDot bgColor={stageType?.color} className='me-2' /><span className='fs-6 '>{stageType?.name}</span></div>,
          label:stageType.name,
          value: stageType?.id,
        }));
        return responseData || {};
      },
    }),
    getStageGroups: builder.mutation({
      query: (params) => ({
        url: `${PIPELINE_URL}/stage-groups`,
        method: 'GET',
        params: params
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.stageGroups?.map((stageType) => ({
          ...stageType,
          label:stageType.name,
          value: stageType?.name,
        }));
        return responseData || {};
      },
    }),
  })
})

export const {
  useUpdatePipelineTemplatesMutation,
  useDeletePipelineTemplateMutation,
  useGetPipelineTemplatesQuery,
  useGetTemplatesPipeMutation,
  useCreatePipelineTemplatesMutation,
  useGetDefaultPipelineTemplatesQuery,
  useGetSelectedPipelineTemplatesMutation,
  useSavePipelineStagesMutation,
  useJobDefaultPipelineStagesMutation,
  useJobSelectedPipelineStagesMutation,
  useJobPipelineStageSwitchMutation,
  useJobCreatePipelineTemplatesMutation,
  useCreateSettingsPipelineTemplatesMutation,
  useDeletePipelineTemplateStageMutation,
  useGetStageTypesMutation,
  useGetStageGroupsMutation,
} = pipelineApiSlice;
